import React from "react";
import styled from "styled-components";

interface HamburgerMenuProps {
  open: boolean;
  setOpen: (v: boolean) => void;
}

export const StyledHamburgerMenu = styled.button<{ open: boolean }>`
  position: absolute;
  right: 0px;
  top: 8px;
  width: 2rem;
  height: 2rem;
  padding: 0;
  background: transparent;

  border: none;
  cursor: pointer;
  outline: none;
  z-index: 12;

  div {
    position: relative;
    width: 20px;
    height: 2px;
    margin-bottom: 5px;
    border-radius: 10px;
    transition: all 0.3s linear;
    transform-origin: 1px;
    background-color: ${({ open }) => (open ? "white" : "white")};

    :first-child {
      transform: ${({ open }) => (open ? "rotate(48deg)" : "rotate(0)")};
    }

    :nth-child(2) {
      opacity: ${({ open }) => (open ? "0" : "1")};
      transform: ${({ open }) => (open ? "translateX(20px)" : "translateX(0)")};
    }

    :nth-child(3) {
      transform: ${({ open }) => (open ? "rotate(-48deg)" : "rotate(0)")};
    }
  }
`;

const HamburgerMenu: React.FunctionComponent<HamburgerMenuProps> = props => (
  <StyledHamburgerMenu
    open={props.open}
    onClick={() => props.setOpen(!props.open)}
  >
    <div />
    <div />
    <div />
  </StyledHamburgerMenu>
);

export default HamburgerMenu;
